// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_wDH","cls2":"RecommendedPodcastBadge-cls2__yU RecommendedPodcastBadge-cls1_wDH"};